import { render, staticRenderFns } from "./FooterInfomir.vue?vue&type=template&id=bab94dfc&scoped=true"
import script from "./FooterInfomir.vue?vue&type=script&lang=js"
export * from "./FooterInfomir.vue?vue&type=script&lang=js"
import style0 from "./FooterInfomir.vue?vue&type=style&index=0&id=bab94dfc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab94dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab94dfc')) {
      api.createRecord('bab94dfc', component.options)
    } else {
      api.reload('bab94dfc', component.options)
    }
    module.hot.accept("./FooterInfomir.vue?vue&type=template&id=bab94dfc&scoped=true", function () {
      api.rerender('bab94dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/FooterInfomir.vue"
export default component.exports